import { ItemType, PostType } from '@/clients/utoniq-core/schema'
import { config } from '@/config'
import { Camera, File as FilePicker } from '@/core/native'
import { getPlatform } from '@/core/native/app'

export enum OtherType {
  Csv = 'csv',
}

export const getResource = async (
  resourceType: ItemType | PostType | OtherType
): Promise<File | FilePicker.PickFile> => {
  const { getImage } = Camera
  if (
    [
      ItemType.Image,
      ItemType.Wallpaper,
      PostType.Image,
      ItemType.Avatar,
    ].includes(resourceType as never)
  ) {
    const file = await getImage(
      config.upload.mimeTypes.wallpaper,
      capitalizeFirstLetter(resourceType)
    )
    if (file.size > config.upload.limit.image) {
      throw new Error('uploadErrorMaximumSize')
    }
    return file
  }
  if (
    [
      ItemType.Audio,
      ItemType.Video,
      ItemType.Magazine,
      PostType.Sound,
      OtherType.Csv,
    ].includes(resourceType)
  ) {
    const mimeType: Record<string, 'audio' | 'video' | 'pdf' | 'csv'> = {
      [ItemType.Audio]: 'audio',
      [PostType.Sound]: 'audio',
      [ItemType.Video]: 'video',
      [ItemType.Magazine]: 'pdf',
      [OtherType.Csv]: 'csv',
    }
    const file = await FilePicker.pickFile(
      config.upload.mimeTypes[mimeType[resourceType]]
    )
    if (
      !config.upload.mimeTypes[mimeType[resourceType]].includes(file.mimeType)
    ) {
      throw new Error(
        `uploadError${capitalizeFirstLetter(mimeType[resourceType])}Only`
      )
    }

    if (mimeType[resourceType] === ItemType.Video) {
      if (file.size > config.upload.limit[ItemType.Video][getPlatform()])
        throw new Error('uploadErrorMaximumSize')
    } else if (file.size > config.upload.limit[mimeType[resourceType]]) {
      throw new Error('uploadErrorMaximumSize')
    }
    return file
  }
  throw new Error('resourceType unsupported')
}

function capitalizeFirstLetter(string: string): string {
  return string.charAt(0).toUpperCase() + string.slice(1)
}
